import React, {useState, useEffect} from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Button,
  Col,
  Row,
  Label,
  Input
} from "reactstrap";
import LaddaButton, {EXPAND_RIGHT} from "react-ladda";
import PropTypes from "prop-types";
import {CustomFormInput, SelectFormField,FormField} from "../../../utils/FormFields";
import Autosuggest from "../../AutosuggestCompliance";
import { showToast,LegalAddresses } from "../../../utils/Helper";
  


const ModalLegalAddress = ({
  open,
  errors,
  toggle,
  onSave,
  services,
  onChangeAddress,
  disabled,
  loading,
  initial
}) => {

  const [legalAddress, setLegalAddress] = useState(initial);
  const [sending, setSending] = useState(false);
  const [showError, setShowError] = useState(false);
  const saveLegalAddress = () => {
    setShowError(false);
    if(validForm()){
    setSending(true);
    onSave(legalAddress, (result) => {
        if(result){
        setSending(false);
        toggle();
      }
      else{
        setSending(false);
      }
    }
    );
    }else{
      setShowError(true);
      showToast("Please fill all required fields",true)
    }
  };

  const validForm = () => {
    if (legalAddress.LegalAddressCountryId &&
          legalAddress.LegalAddressCityId &&
          legalAddress.LegalAddressStreet){
            return true;
          }
         else {
            return false;
          };
  };

  const fetchCountrySuggestion = name =>
    new Promise((resolve, reject) => {
      services.fetchAutosuggestCoutries({text: name}, response => {
        if (response && response.countries) {
          const suggestions = [];
          response.countries.map(c => {
            suggestions.push({
              id: c.Id,
              name: c.Name
            });
            return {};
          });
          resolve(suggestions);
        } else {
          reject();
        }
      });
    });
  
    useEffect(() => {
      if(initial){
        setSending(false);
        setLegalAddress(initial);
      }else{
        setSending(false);
        setLegalAddress({
          LegalAddressCountryId: undefined,
          LegalAddressCountryName: undefined,
          LegalAddressStateId: undefined,
          LegalAddressStateName: undefined,
          LegalAddressCityId: undefined,
          LegalAddressCityName: undefined,
          LegalAddressStreet: undefined,
          LegalAddressZipCode: 0,
          LegalAddressType:LegalAddresses.Personal
        });
      }
        }, [initial]);

    const changeAddress = (name, value) => {
      setLegalAddress({
        ...legalAddress,
        [name]: value
      });
    }

    const [addressStates, setAddressStates] = useState(undefined);
    const [country, setCountry] = useState({
      id: legalAddress.LegalAddressCountryId
    });
  
    const fetchCitySuggestion = name =>
      new Promise((resolve, reject) => {
        services.fetchGetCityAutosuggest(
          {
            name: name,
            nameState: legalAddress.LegalAddressStateName,
            nameCountry: legalAddress.LegalAddressCountryName
          },
          response => {
            if (response && response.suggestions) {
              const suggestions = [];
              response.suggestions.map(c => {
                suggestions.push({
                  id: c.Id,
                  name: c.Name
                });
                return {};
              });
              resolve(suggestions);
            } else {
              reject();
            }
          }
        );
      });
  
    const fetchStateSuggestion = name =>
      new Promise((resolve, reject) => {
        services.fetchGetStateAutosuggest(
          {nameState: name, nameCountry: legalAddress.LegalAddressCountryName},
          response => {
            if (response && response.suggestions) {
              const suggestions = [];
              response.suggestions.map(c => {
                suggestions.push({
                  id: c.Id,
                  name: c.Name
                });
                return {};
              });
              resolve(suggestions);
            } else {
              reject();
            }
          }
        );
      });
      
  
      const handleChangeCity = (id, value) => {
        setLegalAddress({
          ...legalAddress,
          LegalAddressCityId: id,
          LegalAddressCityName: value
        });
      };
      
  
    const onChangeCity = value => {
        setLegalAddress({...legalAddress, LegalAddressCityName: value, LegalAddressCityId: undefined});
    };
  
    const handleChangeState = (id, value) => {
      setLegalAddress({
        ...legalAddress,
        LegalAddressStateId: id,
        LegalAddressStateName: value,
        LegalAddressCityId: '',
        LegalAddressCityName: '',
      });
    };
  
    const onChangeState = value => {
       setLegalAddress(
        {...legalAddress,
         LegalAddressStateId: undefined,
         LegalAddressStateName: value,
         LegalAddressCityName: '',
         LegalAddressCityId: '',
        });
    };
  
    const handleChangeCountry = (id, value) => {
      setCountry({ id: id });
      setLegalAddress({
        ...legalAddress,
        LegalAddressCountryName: value,
        LegalAddressCountryId: id,
        LegalAddressStateId: '',
        LegalAddressStateName: '',
        LegalAddressCityId: '',
        LegalAddressCityName: '',
      });
    };
    
    const onChangeCountry = value => {
      setCountry({ id: 0})
      setLegalAddress({
        ...legalAddress,
        LegalAddressCountryId: 0,
        LegalAddressCountryName: value,
        LegalAddressStateName: '',
        LegalAddressCityName: '',
        LegalAddressStreetName: '',
        LegalAddressStreet: '',
        LegalAddressNumber: '',
      });
    };


  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {initial === undefined ? "New " : "Edit "}
        Legal Address
      </ModalHeader>
      <ModalBody>
        <Form>
          <div>
            <Row>
              <Col>
                <CustomFormInput
                  label="Legal Address Country: "
                  error={
                    showError && !legalAddress.LegalAddressCountryId
                      ? "Required"
                      : ""
                  }
                >
                  <Autosuggest
                    value={legalAddress.LegalAddressCountryName}
                    onChange={onChangeCountry}
                    fecthSuggestions={fetchCountrySuggestion}
                    onSelect={handleChangeCountry}
                    disabled={disabled}
                  />
                </CustomFormInput>
              </Col>
              <Col>
                <CustomFormInput
                  label="Legal Address State: "
                  error={
                    showError && !legalAddress.LegalAddressStateId
                      ? "Required"
                      : ""
                  }
                >
                  <Autosuggest
                    value={legalAddress.LegalAddressStateName}
                    onChange={onChangeState}
                    fecthSuggestions={fetchStateSuggestion}
                    onSelect={handleChangeState}
                    invalid={
                      showError && !legalAddress.LegalAddressStateId == 0
                    }
                    disabled={
                      disabled || (country.id == 0 && initial && initial.LegalAddressCountryName == '') ||
                      (country.id == 0 && legalAddress.LegalAddressCountryId == 0)
                    }
                  />
                </CustomFormInput>
              </Col>
              <Col>
                <CustomFormInput
                  label="Legal Address City: "
                  error={
                    showError && !legalAddress.LegalAddressCityId
                      ? "Required"
                      : ""
                  }
                >
                  <Autosuggest
                    value={legalAddress.LegalAddressCityName}
                    onChange={onChangeCity}
                    invalid={showError && !legalAddress.LegalAddressCityId == 0}
                    fecthSuggestions={fetchCitySuggestion}
                    onSelect={handleChangeCity}
                    disabled={
                      legalAddress.LegalAddressStateName == "" ||
                      legalAddress.LegalAddressCountryName == "" || 
                      disabled || legalAddress.LegalAddressStateId == undefined
                    }
                  />
                </CustomFormInput>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormField
                  label="Legal Address Street: "
                  error={
                    showError && !legalAddress.LegalAddressStreet
                      ? "Required"
                      : ""
                  }
                  value={legalAddress.LegalAddressStreet}
                  name="LegalAddressStreet"
                  invalid={showError && !legalAddress.LegalAddressStreet}
                  onChange={changeAddress}
                  disabled={disabled}
                />
              </Col>
              <Col>
                <FormField
                  label="Legal Address Number: "
                  value={legalAddress.LegalAddressNumber}
                  error={
                    showError && !legalAddress.LegalAddressNumber
                      ? "Required"
                      : ""
                  }
                  name="LegalAddressNumber"
                  onChange={changeAddress}
                  invalid={showError && !legalAddress.LegalAddressNumber}
                  disabled={disabled}
                />
              </Col>
              <Col>
                <FormField
                  label="Legal Address Zip Code: "
                  value={legalAddress.LegalAddressZipCode}
                  error={
                    showError && !legalAddress.LegalAddressZipCode
                      ? "Required"
                      : ""
                  }
                  name="LegalAddressZipCode"
                  type="number"
                  invalid={showError && !legalAddress.LegalAddressZipCode == 0}
                  onChange={changeAddress}
                  disabled={disabled}
                  decimalScale={0}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <SelectFormField
                  label="Legal Address Type: "
                  selectItems={Object.keys(LegalAddresses)}
                  getSelectItemId={(i) => i}
                  getSelectItemName={(i) => i}
                  onChange={changeAddress}
                  value={legalAddress.LegalAddressType}
                  name="LegalAddressType"
                />
              </Col>
            </Row>
            <FormField
              label="Legal Address Neighbourhood: "
              value={legalAddress.LegalAddressExtraInformation1}
              name="LegalAddressExtraInformation1"
              type="textarea"
              onChange={changeAddress}
              disabled={disabled}
            />
            <FormField
              label="Legal Address References: "
              value={legalAddress.LegalAddressExtraInformation2}
              name="LegalAddressExtraInformation2"
              type="textarea"
              onChange={changeAddress}
              disabled={disabled}
            />
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={sending}
          onClick={() => saveLegalAddress()}
          data-style={EXPAND_RIGHT}
        >
          {sending ? " Saving" : " Save"}
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

export default ModalLegalAddress;
